// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contact-module--wrapper--321yl","textWrapper":"contact-module--textWrapper--1Qip1"};